<template>
  <div>
    <b-card>
      <title-card />
      <content-text />
    </b-card>
    <b-row>
      <b-col>
        <image-card />
      </b-col>
      <b-col>
        <file-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import TitleCard from '@/views/Admin/Laboratory_service_terms/Elements/TitleCard.vue'
import ContentText from '@/views/Admin/Laboratory_service_terms/Elements/Content.vue'
import ImageCard from '@/views/Admin/Laboratory_service_terms/Elements/Image.vue'
import FileCard from '@/views/Admin/Laboratory_service_terms/Elements/FileCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    TitleCard,
    ContentText,
    ImageCard,
    FileCard,
  },
}
</script>
